import React from 'react';
import ReactDOM from 'react-dom/client';

function App() {
  React.useEffect(() => {
    window.location.replace('https://smilemaintainers.com/');
  }, []);

  return (
    <div style={{
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      margin: 0,
      background: '#0A1929',
      color: '#fff',
      textAlign: 'center',
    }}>
      <div>
        <h1>Retainers4U is now SmileMaintainers</h1>
        <p>You are being redirected to{' '}
          <a href="https://smilemaintainers.com/" style={{ color: '#00BFA5' }}>
            smilemaintainers.com
          </a>
        </p>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
